import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <>
      <style>{`
        .not-found-main {
          display: grid;
          min-height: 100vh;
          padding: 6rem 1.5rem;
        }
        
        @media (min-width: 640px) {
          .not-found-main {
            padding: 8rem 1.5rem;
          }
        }
        
        @media (min-width: 1024px) {
          .not-found-main {
            padding: 6rem 2rem;
          }
        }
        
        .not-found-container {
          text-align: center;
        }
        
        .not-found-code {
          font-size: 1rem;
          font-weight: 600;
          color: #4f46e5;
        }
        
        .not-found-title {
          margin-top: 1rem;
          font-size: 3rem;
          font-weight: 600;
          letter-spacing: -0.025em;
          text-wrap: balance;
          color: #111827;
        }
        
        @media (min-width: 640px) {
          .not-found-title {
            font-size: 4.5rem;
          }
        }
        
        .not-found-description {
          margin-top: 1.5rem;
          font-size: 1.125rem;
          font-weight: 500;
          text-wrap: pretty;
          color: #6b7280;
        }
        
        @media (min-width: 640px) {
          .not-found-description {
            font-size: 1.25rem;
            line-height: 2rem;
          }
        }
        
        .not-found-actions {
          margin-top: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1.5rem;
        }
        
        .not-found-button {
          border-radius: 0.375rem;
          background-color: #4f46e5;
          padding: 0.625rem 0.875rem;
          font-size: 0.875rem;
          font-weight: 600;
          color: #ffffff;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          text-decoration: none;
          display: inline-block;
          transition: background-color 0.2s;
        }
        
        .not-found-button:hover {
          background-color: #4338ca;
        }
        
        .not-found-button:focus-visible {
          outline: 2px solid #4f46e5;
          outline-offset: 2px;
        }
      `}</style>
      <main className="not-found-main">
        <div className="not-found-container">
          <p className="not-found-code">404</p>
          <h1 className="not-found-title">Page not found</h1>
          <p className="not-found-description">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <div className="not-found-actions">
            <Link to="/home" className="not-found-button">
              Home
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
